module.exports = __webpack_public_path__ + "img/medicine1.6eb79fd1.jpg";